// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { useCallback, useEffect, useRef } from 'react';
import { Animated, Dimensions, Easing, Platform, Pressable, StyleSheet, View } from 'react-native';
import { useRouter } from 'expo-router';

import { Text } from '@/components/Themed';
import { useI18n } from '@/i18n';
import RoundSummaryScreen from '../../../round/[roundId]/summary';
import appColors from '@/theme/colors';

export default function RoundSummarySheetScreen() {
  const { t } = useI18n();
  const router = useRouter();
  const windowHeight = Dimensions.get('window').height;
  const translateY = useRef(new Animated.Value(windowHeight)).current;

  useEffect(() => {
    Animated.timing(translateY, {
      toValue: 0,
      duration: 260,
      easing: Easing.out(Easing.cubic),
      useNativeDriver: Platform.OS !== 'web',
    }).start();
  }, [translateY]);

  const closeSheet = useCallback(() => {
    Animated.timing(translateY, {
      toValue: windowHeight,
      duration: 180,
      easing: Easing.in(Easing.cubic),
      useNativeDriver: Platform.OS !== 'web',
    }).start(() => {
      router.back();
    });
  }, [router, translateY, windowHeight]);

  return (
    <Pressable style={styles.overlay} onPress={closeSheet}>
      <Animated.View style={[styles.sheet, { transform: [{ translateY }] }]}>
        <View style={styles.header}>
          <Pressable onPress={closeSheet} hitSlop={8}>
            <Text style={styles.backText}>{t('menu.back')}</Text>
          </Pressable>
          <Text style={styles.title}>{t('roundResults.title')}</Text>
          <View style={styles.rightSpacer} />
        </View>
        <Pressable style={styles.content} onPress={() => null}>
          <RoundSummaryScreen />
        </Pressable>
      </Animated.View>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(17,44,27,0.14)',
    justifyContent: 'flex-end',
  },
  sheet: {
    height: '88%',
    backgroundColor: '#07200D',
    borderTopLeftRadius: 18,
    borderTopRightRadius: 18,
    borderWidth: 1,
    borderColor: '#1A3A20',
    overflow: 'hidden',
  },
  header: {
    height: 52,
    paddingHorizontal: 14,
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(42,119,66,0.22)',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#C8C8B0',
  },
  backText: {
    color: appColors.text.primary,
    fontSize: 15,
    fontWeight: '700',
  },
  title: {
    color: appColors.text.primary,
    fontSize: 16,
    fontWeight: '700',
  },
  rightSpacer: {
    width: 56,
  },
  content: {
    flex: 1,
  },
});
